import { DashboardIconWave } from '@hr/common/icons'
import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPersons } from '../../actions/persons/personsgetall'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { jsError, localized } from '../../common/utils'
import { personsSelector } from '../../reducers'

export function ExpiringEmployments({ payrollView = false }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const persons = useSelector(personsSelector)

	const startKey = 'expiringEmployments_startDate'
	const endKey = 'expiringEmployments_endDate'

	const today = new Date().toISOString().split('T')[0]

	const [data, setData] = useState([])

	const [startDate, setStartDate] = useState(
		localStorage.getItem(startKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0],
	)

	const [endDate, setEndDate] = useState(
		localStorage.getItem(endKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0],
	)

	useEffect(() => {
		const fetchPersons = async () => {
			try {
				dispatch(getAllPersons())
			} catch (err) {
				jsError(err)
			}
		}
		fetchPersons()
	}, [dispatch])

	useEffect(() => {
		localStorage.setItem(startKey, startDate)
	}, [startDate])

	useEffect(() => {
		localStorage.setItem(endKey, endDate)
	}, [endDate])

	useEffect(() => {
		if (!persons) return

		const start = new Date(startDate)
		start.setHours(0, 0, 0, 0)

		const end = new Date(endDate)
		end.setHours(23, 59, 59, 999)

		const filteredPersons = persons.filter((person) => {
			const d = person.employmentDetails
			if (!d) return false

			if (!(d.fixedDuration === true && d.fixedDurationEndDate)) return false

			const endDateObj = new Date(d.fixedDurationEndDate)

			return endDateObj >= start && endDateObj <= end
		})

		const tableData = filteredPersons
			.map((person) => ({
				personName: person.name,
				profession: person.employmentDetails?.profession,
				fixedDurationExplanation: person.employmentDetails?.fixedDurationExplanation,
				fixedDurationEndDate: new Date(person.employmentDetails.fixedDurationEndDate),
				messageToPayroll: person.employmentDetails?.endInfo,
				employmentEndDate: person.employmentDetails?.endDate ? new Date(person.employmentDetails.endDate) : null,
			}))
			.sort((a, b) => a.fixedDurationEndDate - b.fixedDurationEndDate)

		setData(tableData)
	}, [persons, startDate, endDate])

	//if (!data) {
	//  return <LoadingContainer />;
	//}
	//
	const isLoading = !persons

	return (
		<>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<span className="starting-employments-icon">
						<DashboardIconWave />
					</span>

					<h4 style={{ margin: 0 }}>{t('ExpiringFixedDurationEmployments', 'Päättyvät määräaikaiset työsuhteet')}</h4>
				</div>

				<div style={{ display: 'flex', gap: '10px' }}>
					<input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

					<input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
				</div>
			</div>

			{isLoading ? (
				<LoadingContainer />
			) : data.length ? (
				<div style={{ overflowX: 'auto' }}>
					<Table>
						<thead>
							<tr>
								<th>{t('Person', 'Henkilö')}</th>
								<th>{t('JobTitle', 'Tehtävänimike')}</th>
								<th>{t('Grounds', 'Peruste')}</th>
								<th>{t('Ending', 'Määräaikaisuus päättyy')}</th>
								{payrollView && <th>{t('MessageToPayroll', 'Viesti palkanlaskentaan')}</th>}
								<th>{t('EmploymentEndDate', 'Työsuhde päättyy')}</th>
							</tr>
						</thead>

						<tbody>
							{data.map((row) => (
								<tr key={row.personName}>
									<td>{row.personName}</td>
									<td>{row.profession}</td>
									<td>{row.fixedDurationExplanation}</td>
									<td>{row.fixedDurationEndDate.toLocaleDateString(localized.resolvedLanguage)}</td>
									{payrollView && <td>{row.messageToPayroll}</td>}
									<td>
										{row.employmentEndDate ? row.employmentEndDate.toLocaleDateString(localized.resolvedLanguage) : ''}
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			) : (
				<p>({t('NoEndingFixed', 'Ei päättyviä määräaikaisia työsuhteita')})</p>
			)}
		</>
	)
}
